export const regexps = {
  email: new RegExp(
    /^(([^<>()[\]\\.,;:\s@\\"]+(\.[^<>()[\]\\.,;:\s@\\"]+)*)|(\\".+\\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  ),
  digits: new RegExp(/^\d+$/),
  "one-digit": new RegExp(/^\d$/),
  phone: new RegExp(/^[\d ()+-]+$/),
};
